export const OffersCardStyles = {
    cardWrapper: {
        width: '100%',
        height: '128px',
        boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.04)',
        background: 'white',
        borderRadius: '16px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'stretch',
        // Top & Bottom center circular cutouts
        maskImage: {xs: `radial-gradient(circle at 108px top, transparent 8px, black 8px),
            radial-gradient(circle at 108px bottom, transparent 8px, black 8px)`, 
            md: `radial-gradient(circle at 136px top, transparent 8px, black 8px),
            radial-gradient(circle at 136px bottom, transparent 8px, black 8px)`},
        maskComposite: 'intersect',
        WebkitMaskImage: {xs: `radial-gradient(circle at 108px top, transparent 8px, black 8px),
            radial-gradient(circle at 108px bottom, transparent 8px, black 8px)`, 
            md: `radial-gradient(circle at 136px top, transparent 8px, black 8px),
            radial-gradient(circle at 136px bottom, transparent 8px, black 8px)`},
        WebkitMaskComposite: 'destination-in',
    },
    cardLeft: {
        padding: '16px',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
    },
    cardImage: {
        width: {xs: '68px', md: '96px'},
        height: {xs: '68px', md: '96px'},
        borderRadius: '1000px',
        border: '1px #CDCDCD solid',
        position: 'relative',
        overflow: 'hidden'
    },
    divider: {
        width: '16px',
        backgroundImage: 'linear-gradient(to bottom, #babac8 50%, rgba(0, 0, 0, 0) 0%)',
        backgroundSize: '1px 8px',
        backgroundPosition: 'center',
        backgroundRepeat: 'repeat-y',
        flexShrink: 0,
    },
    cardRight: {
        width: '100%',
        height: '100%',
        padding: '16px 24px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    category: {
        color: '#252525',
        fontSize: '13px',
        fontWeight: 400,
        lineHeight: '125%',
        // Clamp content to 1 lines
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
    },
    title: {
        color: '#000000',
        fontSize: '17px',
        fontWeight: 500,
        lineHeight: '140%',
        // Clamp content to 2 lines
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },
    expiry: {
        opacity: '0.6'
    },
    expiryWrapper: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        marginTop: 'auto',
    }
}